// extracted by mini-css-extract-plugin
export default {"noInternetPage":"NoInternetPage_noInternetPage__-1kmX","noInternet-img":"NoInternetPage_noInternet-img__ckQai","noInternet-img-mobile":"NoInternetPage_noInternet-img-mobile__DN1WI"};